import { useSelector } from "react-redux";

import { AuthState } from "src/features/auth/reducer";

export function useAuthState(): AuthState {
	return useSelector(({ auth }: { auth: AuthState }) => auth);
}
